/* eslint-disable import-helpers/order-imports */
import fiveLevelFour from './five-level-four';
import fiveLevelFive from './five-level-five';
import doubleArrow from './double-arrow';
import cloud from './cloud';
import close from './close';
import clock from './clock';
import circleClose from './circle-close';
import circleCheck from './circle-check';
import check from './check';
import caution from './caution';
import cast from './cast';
import calendarSystemWorkouts from './calendar-system-workouts';
import calendarNoWorkouts from './calendar-no-workouts';
import calendarFewWorkouts from './calendar-few-workouts';
import calendar from './calendar';
import burgerMenu from './burger-menu';
import arrowUp from './arrow-up';
import arrowRight from './arrow-right';
import arrowLeft from './arrow-left';
import arrowDown from './arrow-down';
import active from './active';
import fiveLevelOne from './five-level-one';
import fiveLevelThree from './five-level-three';
import fiveLevelTwo from './five-level-two';
import fourLevelFour from './four-level-four';
import fourLevelOne from './four-level-one';
import fourLevelThree from './four-level-three';
import fourLevelTwo from './four-level-two';
import goal from './goal';
import hide from './hide';
import info from './info';
import location from './location';
import lock from './lock';
import mail from './mail';
import play from './play';
import plus from './plus';
import pointerDown from './pointer-down';
import pointerLeft from './pointer-left';
import pointerRight from './pointer-right';
import pointerUp from './pointer-up';
import profile from './profile';
import search from './search';
import sedentary from './sedentary';
import shield from './shield';
import show from './show';
import spa from './spa';
import star from './star';
import warning from './warning';
import yogaLevelFour from './yoga-level-four';
import yogaLevelOne from './yoga-level-one';
import yogaLevelThree from './yoga-level-three';
import yogaLevelTwo from './yoga-level-two';

export const ICONS = {
    active,
    close,
    arrowDown,
    arrowLeft,
    arrowRight,
    arrowUp,
    burgerMenu,
    calendar,
    calendarFewWorkouts,
    calendarNoWorkouts,
    calendarSystemWorkouts,
    cast,
    caution,
    check,
    circleCheck,
    circleClose,
    clock,
    cloud,
    doubleArrow,
    fiveLevelFive,
    fiveLevelFour,
    fiveLevelOne,
    fiveLevelThree,
    fiveLevelTwo,
    fourLevelFour,
    fourLevelOne,
    fourLevelThree,
    fourLevelTwo,
    goal,
    hide,
    info,
    location,
    lock,
    mail,
    play,
    plus,
    pointerDown,
    pointerLeft,
    pointerRight,
    pointerUp,
    profile,
    search,
    sedentary,
    shield,
    show,
    spa,
    star,
    warning,
    yogaLevelFour,
    yogaLevelOne,
    yogaLevelThree,
    yogaLevelTwo,
} as const;
